<div class="create-challenge" *ngIf="!displayNone">
  <div class="create">Create Your Own Challenge</div>
  <div class="line"></div>
  <div class="start-now" (click)="goToCreateTournament()">
    <a>Start Now</a>
  </div>
</div>